import type { DeviceTokens } from '@/lib/types';

const KEY_DEVICE = 'libretto42.player.deviceToken';
const KEY_REFRESH = 'libretto42.player.refreshToken';
const KEY_DEVICE_ID = 'libretto42.player.deviceId';
const KEY_REFRESH_EXP = 'libretto42.player.refreshExpiresAt';

export function readTokens(): DeviceTokens | null {
  const deviceToken = localStorage.getItem(KEY_DEVICE);
  const refreshToken = localStorage.getItem(KEY_REFRESH);
  const deviceId = localStorage.getItem(KEY_DEVICE_ID);
  const refreshExpiresAt = localStorage.getItem(KEY_REFRESH_EXP);
  if (!deviceToken || !refreshToken || !deviceId || !refreshExpiresAt) return null;
  return { deviceToken, refreshToken, deviceId, refreshExpiresAt };
}

export function writeTokens(t: DeviceTokens): void {
  localStorage.setItem(KEY_DEVICE, t.deviceToken);
  localStorage.setItem(KEY_REFRESH, t.refreshToken);
  localStorage.setItem(KEY_DEVICE_ID, t.deviceId);
  localStorage.setItem(KEY_REFRESH_EXP, t.refreshExpiresAt);
}

export function clearTokens(): void {
  localStorage.removeItem(KEY_DEVICE);
  localStorage.removeItem(KEY_REFRESH);
  localStorage.removeItem(KEY_DEVICE_ID);
  localStorage.removeItem(KEY_REFRESH_EXP);
}

export function isPaired(): boolean {
  return readTokens() !== null;
}
